import React, { useState, useEffect, useContext } from "react";
import Container from "../../components/layout/Container/Container";
import Footer from "../../components/molecules/Footer/Footer";
import Header from "../../components/molecules/Header/Header";
import { IPersonalInfo } from "../../typings/models/PersonalInfo";
import { ErrMsg, NotifyType } from "../../utils/app-config";
import { notify } from "../../utils";
import { helper } from "../../utils/helper";
import { ApplicationStatus, TypeOfApplicationEnum } from "../../utils/enum";
import { Button, Modal, Tab, Tabs } from "react-bootstrap";
import Stepwizard from "../LabDetails/Helper/Stepwizard";
import { IStepwizardProps } from "../../typings/models/StepwizardProps";
import { useSearchParams } from "react-router-dom";
import {
  getAckFile,
  getBioApplication,
  getBioCountryOfDestination,
  getBioCountryOfOrigin,
  getBreedSpeciesSpecimensDetails,
  getCAVSMaster,
  getCountries,
  getPshCavsTestCodeMaster,
  getReportFile,
} from "../../api/apimethods";
import { useNavigate, useLocation } from "react-router-dom";
import { saveFRWApplications, saveLabApplications } from "../../api/apimethods";
import { IFRWPersonalDetails } from "../../typings/models/FRWPersonalDetails";
import PersonalInformation from "./Helper/ProfileInformation";
import { IFRWRequest } from "../../typings/interfaces/Requests/FRWRequest";
import { IFRWSampleDetails } from "../../typings/models/FRWSampleDetails";
import { IFRWSamplesAndTests } from "../../typings/models/FRWSamplesAndTests";
import moment from "moment";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCircleExclamation,
  faCopy,
  faPlus,
  faTrashAlt,
  faTrashCan,
} from "@fortawesome/free-solid-svg-icons";

import { IBioMaster } from "../../typings/models/BioMaster";
import { IBioPurposeOfTest } from "../../typings/models/BioPurposeOfTest";
import { ICodeMasterModel } from "../../typings/models/CodeMasterModel";
import { IlabFRWPreference } from "../../typings/models/FRWPreference";
import { IChooseApp } from "../../typings/models/ChooseApp";
import {
  IFilerInformation,
  tempFilerInfo,
} from "../../typings/models/FilerInformation";
import { ICAVSMaster } from "../../typings/models/CAVSMaster";
import { FRWMetaContext } from "../../App";
import { ILabBreedMaster } from "../../typings/models/LabBreedMaster";
import { ILabSpeciesMaster } from "../../typings/models/LabSpeciesMaster";
import { ILabSpecimenMaster } from "../../typings/models/LabSpecimenMaster";
import { ITestPshCavsCodeMasterModel } from "../../typings/models/PshCavsTestCodeMasterModel";
import { AxiosResponse } from "axios";
import FileSaver from "file-saver";
import { IGetAckFile } from "../../typings/interfaces/Responses/LabApplicationsResponse";
import { ILabTestDetails } from "../../typings/models/LabTestDetails";
import { IBioRequest } from "../../typings/interfaces/Requests/BioRequest";

function CAVSFRWSampleDetails() {
  let personalInfo: IPersonalInfo = JSON.parse(
    localStorage.getItem("profile-info") || ""
  );
  const location = useLocation();
  const currentDate = new Date();
  currentDate.setDate(currentDate.getDate());
  const maxdate = currentDate.toISOString().split("T")[0];
  const [unitSizeOptions, setUnitSizeOptions] = useState<IBioPurposeOfTest[]>();
  const [farmAreaOptions, setFarmAreaOptions] = useState<IBioPurposeOfTest[]>();
  const [labtestoptions, setlabtestoptions] = useState<
    ITestPshCavsCodeMasterModel[]
  >([]);
  const [ageAffectedOptions, setAgeAffectedOptions] =
    useState<IBioPurposeOfTest[]>();
  const [aliveDeadOptions, setAliveDeadOptions] =
    useState<IBioPurposeOfTest[]>();
  const [addressType, setAddressType] = useState<string>("");
  const [selectedTestLaboratory, setSelectedTestLaboratory] =
    useState<string>("");
  const [errorMessage, setErrorMessage] = useState("");
  const [speciesOptions, setSpeciesOptions] = useState<ILabSpeciesMaster[]>();
  const [showCopyControls, setShowCopyControls] = useState(false);
  const [breedOptions, setBreedOptions] = useState<ILabBreedMaster[]>();
  const [samplesToBeCollectedOptions, setSamplesToBeCollectedOptions] =
    useState<IBioPurposeOfTest[]>();
  let attachmentId = "";
  let attachmentedId = "";
  const [specimenOptions, setSpecimenOptions] =
    useState<ILabSpecimenMaster[]>();

  const currentStep = location.state?.currentStep || 2;
  const [countries, setCountries] = useState<any[]>([]);
  const [copyCount, setCopyCount] = useState<number>(1);
  const handleShowModal = () => setShowModal(true);
  const [showPostMortem, setShowPostMortem] = useState(false);
  const [params, setParams] = useSearchParams();
  const [isClinicalManagementExpanded, setIsClinicalManagementExpanded] =
    useState(false);
  const [noOrDiseasedOptions, setNoOrDiseasedOptions] =
    useState<IBioPurposeOfTest[]>();
  const [totalNoOfUnitsOptions, setTotalNoOfUnitsOptions] =
    useState<IBioPurposeOfTest[]>();
  const [showModal, setShowModal] = useState(false);
  const [countryOfOriginOptions, setCountryOfOriginOptions] =
    useState<ICodeMasterModel[]>();
  const [countryOfDestinationOptions, setCountryOfDestinationOptions] =
    useState<ICodeMasterModel[]>();
  const [clinicalHistoryOptions, setClinicalHistoryOptions] =
    useState<IBioPurposeOfTest[]>();
  const { btnLoaderHandler, getFilerInfomation, fileToBase64 } = helper();
  const [isEditMode, setIsEditMode] = useState(false);
  const [AnimalStatus, setAnimalStatus] = useState("");
  const [showGroupAnimals, setShowGroupAnimals] = useState(false);
  const [purposeOfTestOptions, setPurposeOfTestOptions] =
    useState<IBioPurposeOfTest[]>();
  const [searchInd, setSearchInd] = useState(-1);
  const [showForm, setShowForm] = useState(false);
  const [showFarmDetails, setShowFarmDetails] = useState(false);
  const [showFarmLocationDetails, setShowFarmLocationDetails] = useState(false);
  const [saveRemains, setSaveRemains] = useState(false);
  const [euthanised, setEuthanised] = useState(false);
  const [euthanisedDate, setEuthanisedDate] = useState("");
  const [methodOfEuthanised, setMethodOfEuthanised] = useState("");
  const [showQuarantineInfo, setShowQuarantineInfo] = useState(false);
  const [btnNameForLoader, setBtnNameForLoader] = useState<string>("");
  const [pageLoader, setPageLoader] = useState<boolean>(false);
  const [testOptions, setTestOptions] = useState<ITestPshCavsCodeMasterModel[]>(
    []
  );
  const [selectedTestIds, setSelectedTestIds] = useState<
    (number | undefined)[]
  >([]);

  const [amendCase, setAmendCase] = useState<string>("");
  const [submittedFeedback, setSubmittedFeedback] = useState<number>(0);
  const [copyIndex, setCopyIndex] = useState<number | null>(null);
  const [isCancelRequest, setIsCancelRequest] = useState<boolean>(false);
  const [IsAcknowledgeRequest, setIsAcknowledgeRequest] =
    useState<boolean>(false);
  const [cancelComments, setCancelComments] = useState<string>("");
  const [acknowledgmentMessage, setAcknowledgmentMessage] = useState<
    string | null
  >(null);
  const [actionType, setActionType] = useState<string>("");
  const [applicationNum, setApplicationNum] = useState<string>("");
  const [acknowledgmentNumber, setAcknowledgmentNumber] = useState<string>("");
  const [cancelCommentsErrMsg, setCancelCommentsErrMsg] = useState<string>("");
  const [diseasePatternOptions, setDiseasePatternOptions] =
    useState<IBioPurposeOfTest[]>();
  const { FRWMeta } = useContext(FRWMetaContext);
  const handleToggleForm = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();
    setShowForm((prevShowForm) => !prevShowForm);
  };
  const handleLoader = (enableLoader: boolean, btnNameOfLoader: string) => {
    setBtnNameForLoader(enableLoader ? btnNameOfLoader : "");
  };

  const handleToggleFarmLocationDetails = (
    e: React.MouseEvent<HTMLAnchorElement>
  ) => {
    e.preventDefault();

    setShowFarmLocationDetails(
      (prevshowFarmLocationDetails) => !showFarmLocationDetails
    );
  };
  const handleEuthanisedChange = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    const isChecked = event.target.checked;
    setEuthanised(isChecked);
    setFRWSampleDetails((prevState) => ({
      ...prevState,
      euthanised: isChecked,
    }));
  };
  const [showSearchTestsModal, setShowSearchTestsModal] =
    useState<boolean>(false);
  const [testDescription, setTestDescription] = useState<string>("");
  const handleToggleFarmDetails = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();

    setShowFarmDetails((prevShowFarmDetails) => !prevShowFarmDetails);
  };

  const navigate = useNavigate();
  const handlePreviousClick = () => {
    navigate("/choose-application");
  };
  enum sampleDetailMandatoryFields {
    purposeOfTest = "purposeOfTest",
  }

  enum SamplesAndTestMandatoryFields {
    sampleMarking = "sampleMarking",
    samplingFromDate = "samplingFromDate",
    samplingToDate = "samplingToDate",
    labFRWTestDetail = "labFRWTestDetail",
  }

  const amendRestrictionConfig = {
    case1: "CASE1",
    case2: "CASE2",
    case3: `${ApplicationStatus.testingInprogress}`,
    case4: `${ApplicationStatus.applicationClosed},${ApplicationStatus.reportReleased}`,
  };
  const stepWizardConfig: IStepwizardProps = {
    currentStep: 2,
    steps: [
      {
        name: "Choose Application",
      },
      {
        name: "Samples & Tests",
      },
      {
        name: "Review",
      },
      {
        name: "Cost & Confirm",
      },
      {
        name: "Acknowledgement",
      },
    ],
  };
  let bannerName = "Application for Laboratory Testing";
  if (isCancelRequest) {
    bannerName = "Submission of Cancellation Request";
  } else if (amendCase) {
    bannerName = "Submission of Amendment Request";
  }
  const handleNextClick = async () => {
    storeInContext();
    try {
      await getFRWRequestSchema();
      navigate("/frw-review");
      handleLoader(true, "next-click");
      let borderDanger = document.getElementsByClassName("border-danger");
      if (borderDanger.length > 0) {
        message(NotifyType.Error, "Please fill the mandatory fields.");
        handleLoader(false, "next-click");
        return;
      }

      handleLoader(false, "next-click");
    } catch (error) {
      console.error("Error:", error);
      handleLoader(false, "next-click");
    }
  };
  const handleShowSearchTestsModal = (index: number) => {
    setSearchInd(index);
    setShowSearchTestsModal(true);
  };
  let samplesAndTestSchema: IFRWSamplesAndTests = {
    id: Date.now(),
    sampleMarking: "",
    species: "",
    breed: "",
    specimenDescription: "",
    samplingFromDate: "",
    samplingToDate: "",
    sampledBy: "",
    aliveDead: 0,
    numberofSamples: 1,

    numberofTests: 0,
    labFRWTestDetail: [],
  };
  let labFRWPreferenceSchema: IlabFRWPreference = {
    SpecialInstructions: "",
    remarks: "",
    SupportDocuments: "",
    SupportDocumentName: "",
  };
  type CheckboxStates = {
    [key: string]: boolean;
  };
  const handleSamplesAndTestsChange = (
    index: number,
    key: string,
    value: string | Date | boolean
  ) => {
    setSamplesAndTests((prevSamplesAndTests) => {
      const updatedSamplesAndTests = [...prevSamplesAndTests];
      const booleanValue =
        typeof value === "boolean" ? value : value === "true";
      updatedSamplesAndTests[index] = {
        ...updatedSamplesAndTests[index],
        [key]: value,
      };
      return updatedSamplesAndTests;
    });
  };

  const handledFileChange = async (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    if (event.target.files) {
      let file = event.target.files[0];
      const getBase64 = await fileToBase64(file);
      if (getBase64.length) {
        setPreference((prevState) => {
          return {
            ...prevState,
            "SupportDocuments": getBase64,
            "SupportDocumentName": file?.name,
          } as typeof Preference;
        });
      }
    }
  };
  const handleAddTests = () => {
    const testsToAdd = testOptions.filter(
      (test) =>
        test?.labCodeMasterID &&
        selectedTestIds.includes(test.labCodeMasterID as any)
    );

    setTestOptions((prevOptions) =>
      prevOptions.filter(
        (test) => !selectedTestIds.includes(test.labCodeMasterID as any)
      )
    );

    setTestDescription("");
    setSelectedTestLaboratory("");
    setSelectedTestIds([]);

    setSamplesAndTests((prevSamples: any) => {
      return prevSamples.map((prevSample: any, index: number) => {
        if (index === searchInd) {
          const currentTestDetails = prevSample.labFRWTestDetail || [];
          testsToAdd.forEach((test) => {
            const isTestAdded = currentTestDetails.some(
              (detail: any) =>
                detail.testDescription === test.name.trim() &&
                detail.laboratory === selectedTestLaboratory
            );
            if (!isTestAdded) {
              currentTestDetails.push({
                testDescription: test.name.trim(),
                laboratory: selectedTestLaboratory,
              });
            } else {
            }
          });
          return {
            ...prevSample,
            labFRWTestDetail: currentTestDetails,
          };
        } else {
          return prevSample;
        }
      });
    });
  };
  const handleSearch = () => {
    fetchTestCodeMaster();
  };
  const fetchLabTestOptions = async () => {
    try {
      const labMastersResponse: any = await getPshCavsTestCodeMaster({
        PurposeCode: "FRW",
        IsBiosurvillanceUser: false,
      });
      const labMastersData = labMastersResponse.data;
      const labTestOptions = labMastersData.cavsLabMasters.map((item: any) => ({
        labMasterID: item.labMasterID,
        title: item.title,
      }));

      setlabtestoptions(labTestOptions);
    } catch (error) {
      console.error("Error fetching lab test options:", error);
    }
  };

  useEffect(() => {
    fetchLabTestOptions();
  }, []);
  const fetchTestCodeMaster = async () => {
    try {
      const response: any = await getPshCavsTestCodeMaster({
        PurposeCode: "FRW",
        IsBiosurvillanceUser: false,
      });

      if (response.data && response.data.cavs) {
        const selectedLabTitle = selectedTestLaboratory;

        const labMasterID = labtestoptions.find(
          (item: any) => item.title === selectedLabTitle
        )?.labMasterID;

        if (!labMasterID) {
          console.error(
            "Lab Master ID not found for the selected laboratory title:",
            selectedLabTitle
          );
          return;
        }

        let searchString: string = testDescription || "";
        const cavsData = response.data.cavs;

        const customFilter = cavsData.filter(
          (x: any) =>
            x.labId === labMasterID &&
            (x.name
              ? x.name.toLowerCase().indexOf(searchString.toLowerCase()) > -1
              : false)
        );

        const transformedData = customFilter.map((item: any) => ({
          name: item.name,
          labId: item.labId,
          title: item.title,
          labCodeMasterID: item.labCodeMasterID,
        }));
        setTestOptions(transformedData);
      } else {
        const errorMessage = "Failed to retrieve the CAVS data from the API";
        console.log(errorMessage);
        setErrorMessage(errorMessage);
      }
    } catch (error) {
      console.error("Error fetching test code master data:", error);
    }
  };
  const handleCopyButtonClick = (index: number) => {
    if (showCopyControls && copyIndex === index) {
      handleCopyConfirm();
    } else {
      setCopyIndex(index);
      setShowCopyControls(true);
    }
  };

  const handleCopyInputChange = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    setCopyCount(Number(event.target.value));
  };

  const handleCopyConfirm = () => {
    if (copyIndex !== null) {
      handleCopySample(copyIndex, copyCount);
      setCopyIndex(null);
      setCopyCount(1);
      setShowCopyControls(false);
    }
  };
  const [postalCode, setpostalCode] = useState({
    postalCode: "",
    roadName: "",
    houseNo: "",
    buildingName: "",
    CityName: "",
    state: "",
    unitNo: "",
  });

  const handleDownload = async (applicationNum: any) => {
    try {
      const response: AxiosResponse<IGetAckFile> = await getAckFile(
        applicationNum
      );
      const data: IGetAckFile = response.data;
      const attachmentData = data.attachmentData;
      const attachmentId = data.fileName;
      const decodedData = atob(attachmentData);
      const byteCharacters = Array.from(decodedData).map((char) =>
        char.charCodeAt(0)
      );
      const byteArray = new Uint8Array(byteCharacters);

      const blob = new Blob([byteArray], { type: "application/pdf" });

      FileSaver.saveAs(blob, `${attachmentId}`);
    } catch (error) {
      console.error(error);
      message(NotifyType.Info, "Acknowledgement slip is not yet Generated");
    }
  };
  const handledDownload = async (applicationNum: any) => {
    try {
      const response: AxiosResponse<IGetAckFile> = await getReportFile(
        applicationNum
      );
      const data: IGetAckFile = response.data;
      const attachmentData = data.attachmentData;
      attachmentedId = data.fileName;
      const decodedData = atob(attachmentData);
      const byteCharacters = Array.from(decodedData).map((char) =>
        char.charCodeAt(0)
      );
      const byteArray = new Uint8Array(byteCharacters);

      const blob = new Blob([byteArray], { type: "application/pdf" });

      FileSaver.saveAs(blob, `${attachmentedId}`);
    } catch (error) {
      console.error(error);
      message(NotifyType.Info, "Report is not yet Generated");
    }
  };
  const handleAddSample = () => {
    setSamplesAndTests((prevSamples) => {
      const newSample = { ...samplesAndTestSchema, id: Date.now() };
      return [...prevSamples, newSample];
    });
  };

  const handleCopySample = (sampleInd: number, times: number) => {
    const sample: any = samplesAndTests[sampleInd];
    setSamplesAndTests((prevSamples: any) => {
      const newSamples = Array.from({ length: times }, () => ({
        ...sample,
        id: Date.now() + Math.random(),
        disableDelete: false,
        labFRWTestDetail: sample?.labFRWTestDetail?.map((obj: any) => ({
          ...obj,
          disableDelete: false,
        })),
      }));
      return [...prevSamples, ...newSamples];
    });
  };
  const handleCloseSearchTestsModal = () => {
    setShowSearchTestsModal(false);
  };
  const handleDeleteSample = (sampleId: number | undefined) => {
    setSamplesAndTests((samples) =>
      samples.filter((sample) => sample.id !== sampleId)
    );
  };
  const toggleTestSelection = (
    labCodeMasterID: string | undefined,
    isChecked: boolean
  ) => {
    setTestOptions((prevOptions) =>
      prevOptions.map((test) =>
        test.labCodeMasterID === labCodeMasterID
          ? { ...test, isSelected: isChecked }
          : test
      )
    );

    setSelectedTestIds((prevSelected: any) => {
      if (isChecked) {
        return [...prevSelected, labCodeMasterID as string];
      } else {
        return prevSelected.filter((id: any) => id !== labCodeMasterID);
      }
    });
  };

  const [FRWSampleDetails, setFRWSampleDetails] = useState<IFRWSampleDetails>({
    purposeOfTest: 0,
    otherPurposeOfTest: "",
    samplesCollectedOrSubmitted: "",
    countryOfBirth: "",
    countryOfDestination: "",
    courierName: "",
    courierTrackingNo: "",
    importPermitNo: "",
    noOnPremises: 0,
    noInGroup: 0,
    noSick: 0,
    noDead: 0,
    noAtRisk: 0,
    saveRemains: false,
    animalStatus: 0,
    remarks: "",
    euthanised: false,
    euthanisedDate: null,
    methodofEuthanised: "",
    farmLocationName: "",
    addressType: "",
    postalCode: "",
    roadName: "",
    houseNo: "",
    level: "",
    unitNo: "",
    buildingName: "",
    cityName: "",
    state: "",
    country: "",
    history_Remarks: "",
    nameofAnimal: "",
    owner: "",
    microchipNo: "",
    gender: "",
    age: 0,
    years: 0,
    months: 0,
    weeks: 0,
    dateofBirth: null,
    dateOfImport: null,
    dateToBeExported: null,
    countryofResidence: "",
    clinicalHistory: 0,
    diseaseStartedOn: null,
    ago: "",
    diseaseStartedOnOptions: 0,
  });
  const getMaster = async () => {
    try {
      setPageLoader(true);
      const response = await getCAVSMaster();
      if (response.status == 200) {
        // purpose of test
        let purposeOfTest = response?.data?.bioMasters?.testPurpose;
        if (purposeOfTest) {
          let values: number[] = Object.values(purposeOfTest);
          let purposeOfTestArr: IBioPurposeOfTest[] = Object.keys(
            purposeOfTest
          ).map((x, ind) => {
            return {
              id: values[ind],
              name: x,
            };
          });
          setPurposeOfTestOptions(purposeOfTestArr);
        }
        const countryRes = await getBioCountryOfDestination();
        setCountryOfDestinationOptions(countryRes?.data || []);
        setPageLoader(false);

        const conutryRes = await getBioCountryOfOrigin();
        setCountryOfOriginOptions(conutryRes?.data || []);
        setPageLoader(false);

        // samples to be collected or submitted
        let samplesToBeCollected = response?.data?.bioMasters?.samplesCollSub;
        if (samplesToBeCollected) {
          let values: number[] = Object.values(samplesToBeCollected);
          let samplesToBeCollectedArr: IBioPurposeOfTest[] = Object.keys(
            samplesToBeCollected
          ).map((x, ind) => {
            return {
              id: values[ind],
              name: x,
            };
          });
          setSamplesToBeCollectedOptions(samplesToBeCollectedArr);
        }
        // Disease pattern
        let diseasePattern = response?.data?.bioMasters?.diseasePattern;
        if (diseasePattern) {
          let values: number[] = Object.values(diseasePattern);
          let diseasePatternArr: IBioPurposeOfTest[] = Object.keys(
            diseasePattern
          ).map((x, ind) => {
            return {
              id: values[ind],
              name: x,
            };
          });
          setDiseasePatternOptions(diseasePatternArr);
        }
        let noOrDiseased = response?.data?.bioMasters?.noOrDisease;
        if (noOrDiseased) {
          let values: number[] = Object.values(noOrDiseased);
          let noOrDiseasedArr: IBioPurposeOfTest[] = Object.keys(
            noOrDiseased
          ).map((x, ind) => {
            return {
              id: values[ind],
              name: x,
            };
          });
          setNoOrDiseasedOptions(noOrDiseasedArr);
        }
        let totalNoOfUnits = response?.data?.bioMasters?.totalNoOfUnits;
        if (totalNoOfUnits) {
          let values: number[] = Object.values(totalNoOfUnits);
          let totalNoOfUnitsArr: IBioPurposeOfTest[] = Object.keys(
            totalNoOfUnits
          ).map((x, ind) => {
            return {
              id: values[ind],
              name: x,
            };
          });
          setTotalNoOfUnitsOptions(totalNoOfUnitsArr);
        }

        let unitSize = response?.data?.bioMasters?.unitSize;
        if (unitSize) {
          let values: number[] = Object.values(unitSize);
          let unitSizeArr: IBioPurposeOfTest[] = Object.keys(unitSize).map(
            (x, ind) => {
              return {
                id: values[ind],
                name: x,
              };
            }
          );
          setUnitSizeOptions(unitSizeArr);
        }
        let farmArea = response?.data?.bioMasters?.farmArea;
        if (farmArea) {
          let values: number[] = Object.values(farmArea);
          let farmAreaArr: IBioPurposeOfTest[] = Object.keys(farmArea).map(
            (x, ind) => {
              return {
                id: values[ind],
                name: x,
              };
            }
          );
          setFarmAreaOptions(farmAreaArr);
        }
        let ageAffected = response?.data?.bioMasters?.ageAffected;
        if (ageAffected) {
          let values: number[] = Object.values(ageAffected);
          let ageAffectedArr: IBioPurposeOfTest[] = Object.keys(
            ageAffected
          ).map((x, ind) => {
            return {
              id: values[ind],
              name: x,
            };
          });
          setAgeAffectedOptions(ageAffectedArr);
        }
        let aliveDead = response?.data?.bioMasters?.aliveDead;
        if (aliveDead) {
          let values: number[] = Object.values(aliveDead);
          let aliveDeadArr: IBioPurposeOfTest[] = Object.keys(aliveDead).map(
            (x, ind) => {
              return {
                id: values[ind],
                name: x,
              };
            }
          );
          setAliveDeadOptions(aliveDeadArr);
        }
        let clinicalHistory = response?.data?.bioMasters?.clinicalHistory;
        if (clinicalHistory) {
          let values: number[] = Object.values(clinicalHistory);
          let clinicalHistoryArr: IBioPurposeOfTest[] = Object.keys(
            clinicalHistory
          ).map((x, ind) => {
            return {
              id: values[ind],
              name: x,
            };
          });
          setClinicalHistoryOptions(clinicalHistoryArr);
        }
      }

      const breedspeciesresponse = await getBreedSpeciesSpecimensDetails("FRW");

      if (breedspeciesresponse.status == 200) {
        let species = breedspeciesresponse?.data?.labSpecies;

        if (species) {
          let values: any[] = Object.values(species);
          let speciesArr: any[] = Object.keys(species).map((x, ind) => {
            return {
              speciesName: values[ind].speciesName,
            };
          });
          setSpeciesOptions(speciesArr);
        }

        let breeds = breedspeciesresponse?.data?.labBreed;

        if (breeds) {
          let values: any[] = Object.values(breeds);
          let breedArr: any[] = Object.keys(breeds).map((x, ind) => {
            return {
              breedName: values[ind].breedName,
            };
          });
          setBreedOptions(breedArr);
        }

        let specimens = breedspeciesresponse?.data?.labSpecimen;

        if (specimens) {
          let values: any[] = Object.values(specimens);
          let specimensArr: any[] = Object.keys(specimens).map((x, ind) => {
            return {
              labSpecimenDescription: values[ind].labSpecimenDescription,
            };
          });
          setSpecimenOptions(specimensArr);
        }
      }
      const meta: IFRWRequest = FRWMeta.FRWMeta;
      if (Object.keys(meta)?.length) {
        setSamplesAndTests(meta.labFRWSampleTests);
        setFRWSampleDetails(meta.labFRWApplicationDetails);
        setPreference(meta?.labFRWPreference);
      }
      setPageLoader(false);
    } catch (ex) {
      console.error(ex);
      setPageLoader(false);
    }
  };
  useEffect(() => {
    fetchData();
  }, [FRWSampleDetails?.postalCode]);
  const fetchData = async () => {
    try {
      if (!postalCode.postalCode || addressType !== "Local") {
        return;
      }

      const encodedPostalCode = encodeURIComponent(postalCode.postalCode);
      const apiUrl = `https://www.onemap.gov.sg/api/common/elastic/search?searchVal=${encodedPostalCode}&returnGeom=N&getAddrDetails=Y&pageNum=1`;

      const response = await fetch(apiUrl);

      if (!response.ok) {
        throw new Error(`Error: ${response.statusText}`);
      }

      const data = await response.json();

      if (data.found > 0) {
        const { ROAD_NAME, BLK_NO, BUILDING } = data.results[0];

        setFRWSampleDetails((prevDetails) => ({
          ...prevDetails,
          postalCode: postalCode.postalCode,
          roadName: ROAD_NAME,
          houseNo: BLK_NO,
          buildingName: BUILDING,
        }));
      } else {
        setFRWSampleDetails((prevDetails) => ({
          ...prevDetails,
          postalCode: postalCode.postalCode,
          roadName: "",
          houseNo: "",
          buildingName: "",
        }));
      }
    } catch (error) {
      setFRWSampleDetails((prevDetails) => ({
        ...prevDetails,
        postalCode: postalCode.postalCode,
        roadName: "",
        houseNo: "",
        buildingName: "",
      }));
    }
  };
  useEffect(() => {
    getMaster();
  }, []);
  const handleRemoveTest = (
    labDetails: any,
    description: string,
    ind: number
  ) => {
    let removeTheLabID = labDetails.filter(
      (x: ILabTestDetails) => x.testDescription != description
    );
    const newArray = samplesAndTests.map((item: IFRWSamplesAndTests, i) => {
      if (ind === i) {
        return {
          ...item,
          "labFRWTestDetail": removeTheLabID,
        };
      } else {
        return item;
      }
    });
    setSamplesAndTests(newArray);
  };
  const handleFRWSampleDetails = (
    e: React.ChangeEvent<
      HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement
    >,
    type: string
  ) => {
    let name = e.target.name;
    let value: any = e.target.value;

    if (type === "radio" && name === "animalStatus") {
      value = value === "alive" ? 1 : 2;
    }
    if (type === "radio") {
      if ((e.target as HTMLInputElement).checked) {
        setAddressType(value);
        if (name === "addressType" && value === "Local") {
          fetchData();
          setFRWSampleDetails((prevState) => ({
            ...prevState,
            [name]: value,
            country: "Singapore",
          }));
          return;
        }
      }
    } else if (type === "checkbox") {
      value = (e.target as HTMLInputElement).checked;
    } else {
      value = e.target.value;

      if (type === "number") {
        value = Math.max(0, parseInt(value));
      }
      if (type === "date") {
        value =
          value.trim() === ""
            ? null
            : moment(value, "YYYY-MM-DD").toISOString();
      }
    }

    setFRWSampleDetails((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const handleMyPreference = (
    e: React.ChangeEvent<
      HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement
    >,
    type: string
  ) => {
    setPreference((prevState) => {
      const target = e.target as HTMLInputElement;
      switch (type) {
        case "select":
          return {
            ...prevState,
            [target.name]: target.value,
          } as IlabFRWPreference;
        case "checkbox":
          return {
            ...prevState,
            [target.name]: target.checked,
          } as IlabFRWPreference;
        case "input":
          return {
            ...prevState,
            [target.name]: target.value,
          } as IlabFRWPreference;
        default:
          return prevState;
      }
    });
  };

  const [samplesAndTests, setSamplesAndTests] = useState<IFRWSamplesAndTests[]>(
    [
      {
        id: Date.now(),
        sampleMarking: "",
        species: "",
        breed: "",
        specimenDescription: "",

        samplingFromDate: "",
        samplingToDate: "",
        sampledBy: "",
        aliveDead: 0,

        numberofSamples: 1,
        numberofTests: 0,

        labFRWTestDetail: [],
      },
    ]
  );

  const [Preference, setPreference] = useState<IlabFRWPreference>(
    labFRWPreferenceSchema
  );

  const { message } = notify();
  const handleSubmit = async () => {
    try {
      handleLoader(true, "submit-req");

      samplesAndTests.forEach((x) => delete x.id);

      let chooseAppMeta: IChooseApp = {
        typeOfApplication: "FRW",
        typeOfService: "CAVS Laboratory Services",
        applicationType: 0
      };

      const filerInfo: IFilerInformation | null = getFilerInfomation();
      let requestMeta: IFRWRequest = {
        labFRWPersonalInfoDetails: personalInfo,
        labFRWChooseApplDetails: chooseAppMeta,
        labFRWPreference: Preference,
        labFRWSampleTests: samplesAndTests,
        labFRWApplicationDetails: FRWSampleDetails,
        labFRWFilerInfoDetails: filerInfo || tempFilerInfo,
      };
      const response1 = await saveFRWApplications(requestMeta);

      if (response1.status == 200) {
        message(NotifyType.Success, "Request Submitted Successfully");

        localStorage.removeItem("choose-app");
        localStorage.removeItem("FRW-samples-and-tests");
        setTimeout(() => {
          handleLoader(false, "submit-req");
          navigate("/choose-application");
        }, 5000);
      } else {
        message(NotifyType.Error, "Issue on the request submission.");
        handleLoader(false, "submit-req");
      }
    } catch (error) {
      handleLoader(false, "submit-req");
      console.error(ErrMsg.InternalServerErrMsg, error);
      message(NotifyType.Error, ErrMsg.InternalServerErrMsg);
    }
  };

  useEffect(() => {
    const fetchCountries = async () => {
      try {
        const response = await getCountries();

        setCountries(response.data);
      } catch (error) {
        console.error("Error fetching countries:", error);
      }
    };

    fetchCountries();
  }, []);
  // useEffect(() => {
  //   async function checkQueryString() {
  //     setPageLoader(true);
  //
  //     const applicationNum: string | null = params.get("an");
  //     const actionType: string | null = params.get("type");
  //     setActionType(actionType || "");
  //     setApplicationNum(applicationNum || "");

  //     if (applicationNum && actionType) {
  //       try {
  //

  //         const getFRW = await getBioApplication(applicationNum);

  //         if (getFRW.status === 200) {
  //           let result: IFRWRequest = getFRW.data.result;

  //           const FRWSampleDetails = result?.labFRWApplicationDetails;
  //           const FRWPreference = result?.labFRWPreference;
  //           const feedback = result.submittedFeedback || 0;
  //
  //           setSubmittedFeedback(feedback);

  //           if (FRWSampleDetails && FRWPreference) {
  //             setFRWSampleDetails(FRWSampleDetails);
  //             setPreference(FRWPreference);
  //             setPageLoader(true);

  //             if (result?.labFRWSampleTests?.length > 0) {
  //               localStorage.setItem(
  //                 "choose-app",
  //                 JSON.stringify(result.labFRWChooseApplDetails)
  //               );

  //               if (
  //                 actionType === TypeOfApplicationEnum.amendment &&
  //                 result?.actionStatus
  //               ) {
  //                 let amendCase = "";
  //                 if (
  //                   amendRestrictionConfig.case1.indexOf(result?.actionStatus) >
  //                   -1
  //                 ) {
  //                   amendCase = "CASE1";
  //                 } else if (
  //                   amendRestrictionConfig.case2.indexOf(result?.actionStatus) >
  //                   -1
  //                 ) {
  //                   amendCase = "CASE2";
  //                 } else if (
  //                   amendRestrictionConfig.case3.indexOf(result?.actionStatus) >
  //                   -1
  //                 ) {
  //                   amendCase = "CASE3";
  //                 } else if (
  //                   amendRestrictionConfig.case4.indexOf(result?.actionStatus) >
  //                   -1
  //                 ) {
  //                   amendCase = "CASE4";
  //                 }
  //
  //                 setAmendCase(amendCase);
  //               } else if (actionType === TypeOfApplicationEnum.cancel) {
  //
  //                 setIsCancelRequest(true);
  //               } else if (
  //                 actionType === TypeOfApplicationEnum.acknowledgement
  //               ) {
  //
  //                 setIsAcknowledgeRequest(true);
  //               }

  //               let samplesAndTests = result.labFRWSampleTests;
  //               samplesAndTests = samplesAndTests.map((l: any) => {
  //                 return {
  //                   ...l,
  //                   disableDelete: true,
  //                   labFRWTestDetail: l?.labFRWTestDetail?.map((obj: any) => ({
  //                     ...obj,
  //                     disableDelete: true,
  //                   })),
  //                 };
  //               });

  //               setSamplesAndTests(samplesAndTests);
  //             }
  //           }
  //         }
  //       } catch (error) {
  //         console.error("Error fetching data:", error);
  //       } finally {
  //         setPageLoader(false);
  //       }
  //     }
  //   }

  //   checkQueryString();
  // }, []);

  const storeInContext = async () => {
    try {
      let meta: IFRWRequest = await getFRWRequestSchema();

      FRWMeta.updateFRWMeta(meta);
    } catch (error) {
      console.error(error);
    }
  };
  const getFRWRequestSchema = (): IFRWRequest => {
    delete FRWSampleDetails?.countryOfDestinationErrMsg;
    delete FRWSampleDetails?.countryofOriginErrMsg;
    delete FRWSampleDetails?.samplesCollectedOrSubmittedErrMsg;
    delete FRWSampleDetails?.purposeTestErrMsg;
    delete FRWSampleDetails?.otherPurposeOfTestErrMsg;
    let chooseAppMeta: IChooseApp = {
      typeOfService: "CAVS Laboratory Services",
      typeOfApplication: "FRW",
      applicationType: 0
    };

    samplesAndTests.forEach((x) => {
      delete x.id;
      // delete x?.sampleMarkingErrMsg;
      // delete x?.speciesErrMsg;
      // delete x?.breedErrMsg;
      // delete x?.specimenDescriptionErrMsg;
      // delete x?.samplingFromDateErrMsg;
      // delete x?.samplingToDateErrMsg;
      // delete x?.labENVTestDetailsErrMsg;
      // delete x?.noOfSamplesErrMsg;
      // delete x?.noofpoolsErrMsg;
      // delete x?.nooftestsErrMsg;
      delete x?.disableDelete;
      x?.labFRWTestDetail?.forEach((element: any) => {
        delete element?.disableDelete;
      });
    });

    const filerInfo: IFilerInformation | null = getFilerInfomation();
    let personalInfo: IPersonalInfo = JSON.parse(
      localStorage.getItem("profile-info") || ""
    );
    let meta: IFRWRequest = {
      labFRWChooseApplDetails: chooseAppMeta,
      labFRWPersonalInfoDetails: personalInfo,
      labFRWApplicationDetails: {
        ...FRWSampleDetails,
      } as IFRWSampleDetails,
      labFRWSampleTests: samplesAndTests,
      labFRWPreference: Preference,
      actionStatus: actionType || "",
      applicationNumber: applicationNum || "",
      labFRWFilerInfoDetails: filerInfo || tempFilerInfo,
    };

    return meta;
  };

  return (
    <>
      <Header />
      <Container>
        <div className="h1Lab">{bannerName} </div>

        <Stepwizard
          currentStep={stepWizardConfig.currentStep}
          steps={stepWizardConfig.steps}
        />
        <div className="row setup-content" id="step-1">
          <div className="col-md-12">
            <div className="tab-wizard-content">
              <PersonalInformation />

              <Tabs
                className="samples-and-tests-cavs"
                defaultActiveKey={1}
                id="uncontrolled-tab-example"
              >
                <Tab eventKey={1} title="Sample Details">
                  <div className="personal-info">
                    <div className="info-heading">
                      <h2 className="pb-0">Sample Details</h2>
                    </div>
                    <div className="info-content">
                      <div className="row">
                        <div className="row">
                          <div className="col-lg-6">
                            <div className="row">
                              <div className="col-lg-6">
                                <label className="form-check-label" htmlFor="">
                                  Purpose of Application
                                  <span className="star-red">*</span>
                                </label>
                              </div>
                              <div className="col-lg-6">
                                <select
                                  className={`form-select ${
                                    FRWSampleDetails?.purposeOfTestErrMsg
                                      ? "border-danger op05"
                                      : ""
                                  }`}
                                  aria-label="Default select example"
                                  name="purposeOfTest"
                                  onChange={(e) =>
                                    handleFRWSampleDetails(e, "number")
                                  }
                                  // disabled={
                                  //   amendCase == "CASE4" ||
                                  //   isCancelRequest ||
                                  //   IsAcknowledgeRequest
                                  // }
                                  value={FRWSampleDetails?.purposeOfTest}
                                >
                                  <option selected>-- Select --</option>
                                  {purposeOfTestOptions &&
                                    purposeOfTestOptions.map((x) => {
                                      return (
                                        <option value={x.id}>{x.name}</option>
                                      );
                                    })}
                                </select>
                                {FRWSampleDetails?.purposeOfTestErrMsg && (
                                  <div className="error-message">
                                    <FontAwesomeIcon
                                      className="me-1"
                                      icon={faCircleExclamation}
                                    />
                                    Please fill Purpose of Application.
                                  </div>
                                )}

                                {FRWSampleDetails?.purposeOfTest === 7 && (
                                  <div className="col-lg-12 mt-2">
                                    <input
                                      type="text"
                                      className={`form-control ${
                                        !FRWSampleDetails?.otherPurposeOfTest
                                          ? "border-danger op05"
                                          : ""
                                      }`}
                                      // disabled={
                                      //   amendCase == "CASE4" ||
                                      //   isCancelRequest ||
                                      //   IsAcknowledgeRequest
                                      // }
                                      placeholder="Enter Purpose of Application"
                                      name="otherPurposeOfTest"
                                      value={
                                        FRWSampleDetails?.otherPurposeOfTest
                                      }
                                      onChange={(e) =>
                                        handleFRWSampleDetails(e, "string")
                                      }
                                    />
                                    {/* {FRWSampleDetails?.otherPurposeOfTestErrMsg && (
                                      <div className="error-message">
                                        <FontAwesomeIcon
                                          className="me-1"
                                          icon={faCircleExclamation}
                                        />
                                        {
                                          FRWSampleDetails?.otherPurposeOfTestErrMsg
                                        }
                                      </div>
                                    )} */}
                                  </div>
                                )}
                              </div>
                            </div>
                          </div>
                          <div className="col-lg-6">
                            <div className="row">
                              <div className="col-lg-6">
                                <label
                                  className="form-check-label"
                                  htmlFor="samples"
                                >
                                  Sample(s) to be collected or submitted?
                                </label>
                              </div>
                              <div className="col-lg-6">
                                <select
                                  title="samples"
                                  name="samplesCollectedOrSubmitted"
                                  className="form-control"
                                  value={
                                    FRWSampleDetails?.samplesCollectedOrSubmitted
                                  }
                                  disabled
                                  required
                                >
                                  <option value="Tobesubmitted">
                                    To be submitted
                                  </option>
                                </select>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="row mt-2">
                          <div className="col-lg-6">
                            <div className="row">
                              <div className="col-lg-6">
                                <label
                                  className="form-check-label"
                                  htmlFor="courierName"
                                >
                                  Courier Name
                                </label>
                              </div>
                              <div className="col-lg-6">
                                <select
                                  title="courierName"
                                  name="courierName"
                                  className="form-control"
                                  value={FRWSampleDetails?.courierName}
                                  disabled={
                                    amendCase == "CASE4" ||
                                    isCancelRequest ||
                                    IsAcknowledgeRequest
                                  }
                                  onChange={(e) =>
                                    handleFRWSampleDetails(e, "string")
                                  }
                                >
                                  <option value="courierOption1">
                                    Courier Option 1
                                  </option>
                                  <option value="courierOption2">
                                    Courier Option 2
                                  </option>
                                </select>
                              </div>
                            </div>
                          </div>
                          <div className="col-lg-6">
                            <div className="row mt-2 mt-lg-0">
                              <div className="col-lg-6">
                                <label
                                  className="form-check-label"
                                  htmlFor="courierTrackingNumber"
                                >
                                  Courier tracking number
                                </label>
                              </div>
                              <div className="col-lg-6">
                                <input
                                  type="text"
                                  id="courierTrackingNumber"
                                  name="courierTrackingNo"
                                  className="form-control"
                                  value={FRWSampleDetails?.courierTrackingNo}
                                  disabled={
                                    amendCase == "CASE4" ||
                                    isCancelRequest ||
                                    IsAcknowledgeRequest
                                  }
                                  onChange={(e) =>
                                    handleFRWSampleDetails(e, "string")
                                  }
                                />
                              </div>
                            </div>
                          </div>
                        </div>

                        <div className="row mt-2">
                          <div className="col-lg-6">
                            <div className="row">
                              <div className="col-lg-6">
                                <label className="form-check-label" htmlFor="">
                                  Country of Origin
                                </label>
                              </div>
                              <div className="col-lg-6">
                                <select
                                  className="form-select"
                                  aria-label="Default select example"
                                  name="countryOfBirth"
                                  value={FRWSampleDetails?.countryOfBirth}
                                  disabled={
                                    amendCase == "CASE4" ||
                                    isCancelRequest ||
                                    IsAcknowledgeRequest
                                  }
                                  onChange={(e) =>
                                    handleFRWSampleDetails(e, "string")
                                  }
                                >
                                  <option selected>-- Select --</option>
                                  {countryOfOriginOptions &&
                                    countryOfOriginOptions.map((x) => {
                                      return (
                                        <option value={x.name}>{x.name}</option>
                                      );
                                    })}
                                </select>
                              </div>
                            </div>
                          </div>

                          <div className="col-lg-6">
                            <div className="row mt-2 mt-lg-0">
                              <div className="col-lg-6">
                                <label className="form-check-label" htmlFor="">
                                  Date of Import
                                </label>
                              </div>
                              <div className="col-lg-6">
                                <div
                                  className="input-group date"
                                  id="datepicker"
                                >
                                  <input
                                    type="date"
                                    className={`form-control`}
                                    name="dateOfImport"
                                    max={maxdate}
                                    value={
                                      FRWSampleDetails?.dateOfImport
                                        ? moment(
                                            FRWSampleDetails?.dateOfImport
                                          ).format("YYYY-MM-DD")
                                        : ""
                                    }
                                    disabled={
                                      amendCase == "CASE4" ||
                                      isCancelRequest ||
                                      IsAcknowledgeRequest
                                    }
                                    onChange={(e) =>
                                      handleFRWSampleDetails(e, "date")
                                    }
                                  />
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="row mt-2">
                          <div className="col-lg-3">
                            <label className="form-check-label" htmlFor="">
                              Import Permit/License No.
                            </label>
                          </div>
                          <div className="col-lg-3">
                            <input
                              type="text"
                              className="form-control"
                              placeholder=""
                              name="importPermitNo"
                              value={FRWSampleDetails?.importPermitNo}
                              disabled={
                                amendCase == "CASE4" ||
                                isCancelRequest ||
                                IsAcknowledgeRequest
                              }
                              onChange={(e) =>
                                handleFRWSampleDetails(e, "string")
                              }
                            />
                          </div>
                        </div>

                        <div className="row mt-2">
                          <div className="col-lg-3">
                            <label
                              className="form-check-label"
                              htmlFor="countryOfDestination"
                            >
                              Country of Destination
                              <span className="star-red">*</span>
                            </label>
                          </div>
                          <div className="col-lg-3">
                            <select
                              id="countryOfDestination"
                              name="countryOfDestination"
                              value={FRWSampleDetails?.countryOfDestination}
                              disabled={
                                amendCase == "CASE4" ||
                                isCancelRequest ||
                                IsAcknowledgeRequest
                              }
                              className="form-select"
                              onChange={(e) =>
                                handleFRWSampleDetails(e, "string")
                              }
                              required
                            >
                              <option value="" disabled hidden>
                                Choose a Country
                              </option>
                              {countryOfDestinationOptions &&
                                countryOfDestinationOptions.map((x) => {
                                  return (
                                    <option value={x.name}>{x.name}</option>
                                  );
                                })}
                            </select>
                          </div>

                          <div className="col-lg-3">
                            <label
                              className="form-check-label"
                              htmlFor="dateToBeExported"
                            >
                              Date to be Exported
                            </label>
                          </div>
                          <div className="col-lg-3">
                            <input
                              type="date"
                              id="dateToBeExported"
                              name="dateToBeExported"
                              disabled={
                                amendCase == "CASE4" ||
                                isCancelRequest ||
                                IsAcknowledgeRequest
                              }
                              value={
                                FRWSampleDetails?.dateToBeExported
                                  ? moment(
                                      FRWSampleDetails?.dateToBeExported
                                    ).format("YYYY-MM-DD")
                                  : ""
                              }
                              className="form-control"
                              max={maxdate}
                              onChange={(e) =>
                                handleFRWSampleDetails(e, "date")
                              }
                            />
                          </div>
                        </div>
                      </div>
                      <div className="row mt-3">
                        <div className="col-lg-12">
                          <label
                            className="form-check-label"
                            htmlFor="flexRadioDefault1"
                          >
                            <a
                              href=""
                              className="font-weight-500"
                              onClick={(e) => {
                                e.preventDefault();
                                setShowGroupAnimals(!showGroupAnimals);
                              }}
                            >
                              For Group Animals:{" "}
                              {showGroupAnimals ? "[-]" : "[+]"}
                            </a>
                          </label>
                        </div>
                      </div>

                      {showGroupAnimals && (
                        <>
                          <div className="row">
                            <div className="col-lg-3">
                              <label
                                className="form-check-label"
                                htmlFor="noOnPremises"
                              >
                                No. on Premises
                              </label>
                            </div>
                            <div className="col-lg-1">
                              <input
                                type="number"
                                className="form-control"
                                name="noOnPremises"
                                value={FRWSampleDetails?.noOnPremises}
                                onChange={(e) =>
                                  handleFRWSampleDetails(e, "number")
                                }
                              />
                            </div>

                            <div className="col-lg-2">
                              <label
                                className="form-check-label"
                                htmlFor="noInGroupPen"
                              >
                                No. in Group/Pen
                              </label>
                            </div>
                            <div className="col-lg-1">
                              <input
                                type="number"
                                className="form-control"
                                name="noInGroup"
                                value={FRWSampleDetails?.noInGroup}
                                onChange={(e) =>
                                  handleFRWSampleDetails(e, "number")
                                }
                              />
                            </div>
                          </div>

                          <div className="row">
                            <div className="col-lg-3">
                              <label
                                className="form-check-label"
                                htmlFor="noSick"
                              >
                                No. Sick
                              </label>
                            </div>
                            <div className="col-lg-1">
                              <input
                                type="number"
                                className="form-control"
                                name="noSick"
                                value={FRWSampleDetails?.noSick}
                                onChange={(e) =>
                                  handleFRWSampleDetails(e, "number")
                                }
                              />
                            </div>

                            <div className="col-lg-2">
                              <label
                                className="form-check-label"
                                htmlFor="noDead"
                              >
                                No. Dead
                              </label>
                            </div>
                            <div className="col-lg-1">
                              <input
                                type="number"
                                className="form-control"
                                name="noDead"
                                value={FRWSampleDetails?.noDead}
                                onChange={(e) =>
                                  handleFRWSampleDetails(e, "number")
                                }
                              />
                            </div>

                            <div className="col-lg-2">
                              <label
                                className="form-check-label"
                                htmlFor="noAtRisk"
                              >
                                No. at Risk
                              </label>
                            </div>
                            <div className="col-lg-1">
                              <input
                                type="number"
                                className="form-control"
                                name="noAtRisk"
                                value={FRWSampleDetails?.noAtRisk}
                                onChange={(e) =>
                                  handleFRWSampleDetails(e, "number")
                                }
                              />
                            </div>
                          </div>
                        </>
                      )}

                      <div className="row mt-3">
                        <div className="col-lg-12">
                          <label
                            className="form-check-label"
                            htmlFor="flexRadioDefault1"
                          >
                            <a
                              href=""
                              className="font-weight-500"
                              onClick={(e) => {
                                e.preventDefault();
                                setShowPostMortem(!showPostMortem);
                              }}
                            >
                              For Post Mortem: {showPostMortem ? "[-]" : "[+]"}
                            </a>
                          </label>
                        </div>
                      </div>
                      {showPostMortem && (
                        <div className="row mt-2">
                          <div className="col-lg-3">
                            <label className="form-check-label">
                              Animal Status{" "}
                            </label>
                          </div>
                          <div className="col-lg-3">
                            <div className="form-checked">
                              <label
                                htmlFor="alive"
                                className="form-check-label"
                              >
                                <input
                                  type="radio"
                                  name="animalStatus"
                                  value="1"
                                  className="form-check-input"
                                  checked={FRWSampleDetails?.animalStatus === 1}
                                  onChange={(e) =>
                                    handleFRWSampleDetails(e, "number")
                                  }
                                />
                                Alive
                              </label>
                              <label
                                htmlFor="dead"
                                className="form-check-label"
                              >
                                <input
                                  type="radio"
                                  name="animalStatus"
                                  value="2"
                                  className="form-check-input"
                                  checked={FRWSampleDetails?.animalStatus === 2}
                                  onChange={(e) =>
                                    handleFRWSampleDetails(e, "number")
                                  }
                                />
                                Dead
                              </label>
                            </div>
                          </div>

                          <div className="row mt-2">
                            <div className="col-lg-6 form-check">
                              <input
                                type="checkbox"
                                className="form-check-input"
                                name="saveRemains"
                                id="saveRemains"
                                checked={FRWSampleDetails?.saveRemains}
                                onChange={(e) =>
                                  handleFRWSampleDetails(e, "checkbox")
                                }
                              />
                              <label
                                className="form-check-label"
                                htmlFor="saveRemains"
                              >
                                Save Remains for Burial/Cremation
                              </label>
                            </div>
                            <div className="col-lg-6">
                              <div className="row">
                                <div className="col-lg-12">
                                  <div className="form-group row">
                                    <div className="col-lg-6">
                                      <label
                                        className="form-check-label"
                                        htmlFor="Remarks"
                                      >
                                        Remarks
                                      </label>
                                    </div>
                                    <div className="col-lg-6">
                                      <input
                                        type="text"
                                        className="form-control"
                                        name="remarks"
                                        value={FRWSampleDetails?.remarks}
                                        onChange={(e) =>
                                          handleFRWSampleDetails(e, "string")
                                        }
                                      />
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>

                          <div className="row mt-2">
                            <div className="form-check col-lg-6">
                              <input
                                type="checkbox"
                                className="form-check-input mt10"
                                id="euthanised"
                                checked={FRWSampleDetails?.euthanised}
                                onChange={handleEuthanisedChange}
                                disabled={
                                  amendCase == "CASE4" ||
                                  isCancelRequest ||
                                  IsAcknowledgeRequest
                                }
                              />
                              <label
                                className="form-check-label"
                                htmlFor="euthanised"
                              >
                                Euthanised
                              </label>
                            </div>
                            {euthanised && (
                              <div className="row mt-2">
                                <div className="col-lg-3">
                                  <label
                                    htmlFor="euthanisedDate"
                                    className="form-check-label"
                                  >
                                    Euthanised Date
                                  </label>
                                </div>
                                <div className="col-lg-3">
                                  <input
                                    type="date"
                                    id="euthanisedDate"
                                    name="euthanisedDate"
                                    value={
                                      FRWSampleDetails?.euthanisedDate ?? ""
                                    }
                                    className="form-control"
                                    onChange={(e) =>
                                      handleFRWSampleDetails(e, "string")
                                    }
                                    max={maxdate}
                                  />
                                </div>
                              </div>
                            )}
                            {euthanised && (
                              <div className="row mt-2">
                                <div className="col-lg-3">
                                  <label
                                    htmlFor="methodOfEuthanised"
                                    className="col-form-label"
                                  >
                                    Method of Euthanasia
                                  </label>
                                </div>
                                <div className="col-lg-3">
                                  <input
                                    type="text"
                                    id="methodOfEuthanised"
                                    name="methodofEuthanised"
                                    value={FRWSampleDetails?.methodofEuthanised}
                                    className="form-control"
                                    onChange={(e) =>
                                      handleFRWSampleDetails(e, "string")
                                    }
                                  />
                                </div>
                              </div>
                            )}
                          </div>
                        </div>
                      )}

                      <div className="col-lg-3">
                        <label className="form-check-label">
                          <a
                            href="#"
                            className="font-weight-500"
                            onClick={handleToggleFarmLocationDetails}
                          >
                            Farm/Location Details{" "}
                            {showFarmLocationDetails ? "[-]" : "[+]"}
                          </a>
                        </label>
                      </div>
                      {showFarmLocationDetails && (
                        <>
                          <div className="row">
                            <div className="col-lg-3">
                              <label
                                className="form-check-label"
                                htmlFor="farmLocationName"
                              >
                                Location Name
                              </label>
                            </div>
                            <div className="col-lg-3">
                              <input
                                type="text"
                                className="form-control"
                                name="farmLocationName"
                                value={FRWSampleDetails?.farmLocationName}
                                onChange={(e) =>
                                  handleFRWSampleDetails(e, "string")
                                }
                              />
                            </div>
                          </div>
                          <div className="row">
                            <div className="col-lg-3">
                              <label className="form-check-label">
                                Farm/Location Address
                              </label>
                            </div>
                            <div className="col-lg-3">
                              <div className="form-checked">
                                <label
                                  htmlFor="local"
                                  className="form-check-label"
                                >
                                  <input
                                    type="radio"
                                    id="local"
                                    name="addressType"
                                    value="Local"
                                    className="form-check-input"
                                    onChange={(e) =>
                                      handleFRWSampleDetails(e, "radio")
                                    }
                                    checked={addressType === "Local"}
                                  />
                                  Local
                                </label>
                                <label
                                  htmlFor="foreign"
                                  className="form-check-label"
                                >
                                  <input
                                    type="radio"
                                    id="foreign"
                                    name="addressType"
                                    className="form-check-input"
                                    value="Foreign"
                                    onChange={(e) =>
                                      handleFRWSampleDetails(e, "radio")
                                    }
                                    checked={addressType === "Foreign"}
                                  />
                                  Foreign
                                </label>
                              </div>
                            </div>
                          </div>
                          <div className="addresss">
                            <div className="row mt-2">
                              <div className="col-lg-9">
                                <div>
                                  <label className="form-check-label">
                                    Postal Code
                                  </label>

                                  <input
                                    type="text"
                                    className="form-control"
                                    name="postalCode"
                                    value={FRWSampleDetails?.postalCode}
                                    onChange={(e) =>
                                      handleFRWSampleDetails(e, "number")
                                    }
                                  />
                                </div>
                              </div>
                              <div className="col-lg-3">
                                <div className="row">
                                  <div className="col-lg-12">
                                    <label htmlFor="button"></label>
                                    <br />
                                    <div>
                                      <Button
                                        className="btttn"
                                        onClick={fetchData}
                                      >
                                        Retrieve
                                      </Button>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div className="row mt-2">
                                <div>
                                  <label htmlFor="streetRoadName">
                                    Street/Road Name
                                  </label>

                                  <input
                                    type="text"
                                    className="form-control"
                                    name="roadName"
                                    value={FRWSampleDetails?.roadName}
                                    onChange={(e) =>
                                      handleFRWSampleDetails(e, "string")
                                    }
                                  />
                                </div>
                              </div>
                              <div className="row mt-4">
                                <div className="col-lg-4">
                                  <label htmlFor="blockHouseNo">
                                    Block/House No
                                  </label>
                                  <input
                                    type="text"
                                    className="form-control"
                                    name="houseNo"
                                    value={FRWSampleDetails?.houseNo}
                                    onChange={(e) =>
                                      handleFRWSampleDetails(e, "string")
                                    }
                                  />
                                </div>
                                <div className="block">
                                  <label htmlFor="level">Level</label>
                                  <input
                                    type="text"
                                    className="form-control"
                                    name="level"
                                    value={FRWSampleDetails?.level}
                                    onChange={(e) =>
                                      handleFRWSampleDetails(e, "string")
                                    }
                                  />
                                </div>
                                <div className="col-lg-4">
                                  <label htmlFor="unitNo">Unit No</label>
                                  <input
                                    type="text"
                                    className="form-control"
                                    name="unitNo"
                                    value={FRWSampleDetails?.unitNo}
                                    onChange={(e) =>
                                      handleFRWSampleDetails(e, "string")
                                    }
                                  />
                                </div>
                              </div>
                              <div className="row">
                                <div className="col-lg-4">
                                  <label htmlFor="buildingName">
                                    Building Name
                                  </label>
                                </div>
                                <div className="col-lg-12">
                                  <input
                                    type="text"
                                    className="form-control"
                                    name="buildingName"
                                    value={FRWSampleDetails?.buildingName}
                                    onChange={(e) =>
                                      handleFRWSampleDetails(e, "string")
                                    }
                                  />
                                </div>

                                <div className="row mt-2">
                                  <div className="col-lg-6">
                                    <label htmlFor="CityName">City Name</label>
                                    <input
                                      type="text"
                                      id="CityName"
                                      name="cityName"
                                      value={FRWSampleDetails?.cityName}
                                      className="form-control"
                                      onChange={(e) =>
                                        handleFRWSampleDetails(e, "string")
                                      }
                                      maxLength={255}
                                    />
                                  </div>

                                  <div className="col-lg-6">
                                    <label htmlFor="State">
                                      State/Province
                                    </label>
                                    <input
                                      type="text"
                                      id="state"
                                      name="state"
                                      value={FRWSampleDetails?.state}
                                      className="form-control"
                                      onChange={(e) =>
                                        handleFRWSampleDetails(e, "string")
                                      }
                                      maxLength={255}
                                    />
                                  </div>
                                </div>
                              </div>
                            </div>{" "}
                            <div className="row">
                              <div className="col-lg-3">
                                <label
                                  className="form-check-label"
                                  htmlFor="country"
                                >
                                  Country
                                </label>
                              </div>
                              <div className="col-lg-12">
                                <input
                                  type="text"
                                  className="form-control"
                                  name="country"
                                  value={FRWSampleDetails?.country}
                                  onChange={(e) =>
                                    handleFRWSampleDetails(e, "string")
                                  }
                                />
                              </div>
                            </div>
                          </div>
                        </>
                      )}

                      <div className="row mt-3">
                        <div className="col-lg-12">
                          <label
                            className="form-check-label"
                            htmlFor="flexRadioDefault1"
                          >
                            <a
                              href="#"
                              className="font-weight-500"
                              onClick={handleToggleForm}
                            >
                              History & Remarks: {showForm ? "[-]" : "[+]"}
                            </a>
                          </label>
                        </div>
                      </div>
                      {showForm && (
                        <div className="row">
                          <div className="col-lg-3">
                            <label htmlFor="historyAndRemarks"></label>
                          </div>
                          <div className="col-lg-9">
                            <textarea
                              id="history_Remarks"
                              name="history_Remarks"
                              value={FRWSampleDetails?.history_Remarks}
                              className="form-control"
                              onChange={(e) =>
                                handleFRWSampleDetails(e, "string")
                              }
                              maxLength={155}
                            />
                          </div>
                        </div>
                      )}

                      <div className="col-lg-3">
                        <label className="form-check-label">
                          <a
                            href="#"
                            className="font-weight-500"
                            onClick={handleToggleFarmDetails}
                          >
                            Animal/pets Information
                            {showFarmDetails ? "[-]" : "[+]"}
                          </a>
                        </label>
                      </div>
                      {showFarmDetails && (
                        <>
                          <div className="row">
                            <div className="col-lg-3">
                              <label
                                className="form-check-label"
                                htmlFor="owner"
                              >
                                Owner
                              </label>
                            </div>
                            <div className="col-lg-3">
                              <input
                                type="text"
                                className="form-control"
                                name="owner"
                                value={FRWSampleDetails?.owner}
                                onChange={(e) =>
                                  handleFRWSampleDetails(e, "string")
                                }
                              />
                            </div>
                          </div>
                          <div className="row">
                            <div className="col-lg-6">
                              <div className="row">
                                <div className="col-lg-6">
                                  <label
                                    className="form-check-label"
                                    htmlFor="nameOfAnimal"
                                  >
                                    Name of Animal
                                  </label>
                                </div>
                                <div className="col-lg-6">
                                  <input
                                    type="text"
                                    className="form-control"
                                    name="nameofAnimal"
                                    value={FRWSampleDetails?.nameofAnimal}
                                    onChange={(e) =>
                                      handleFRWSampleDetails(e, "string")
                                    }
                                    placeholder=""
                                  />
                                </div>
                              </div>
                            </div>
                            <div className="col-lg-6">
                              <div className="row">
                                <div className="col-lg-4">
                                  <label
                                    className="form-check-label"
                                    htmlFor="idMicrochipNo"
                                  >
                                    ID/Microchip No.
                                  </label>
                                </div>

                                <div className="col-lg-6">
                                  <input
                                    type="text"
                                    className="form-control"
                                    name="microchipNo"
                                    value={FRWSampleDetails?.microchipNo}
                                    onChange={(e) =>
                                      handleFRWSampleDetails(e, "string")
                                    }
                                  />
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="row">
                            <div className="col-lg-3">
                              <label className="form-check-label">Gender</label>
                            </div>
                            <div className="col-lg-4">
                              <div className="form-checked">
                                <label
                                  className="form-check-label"
                                  htmlFor="Male"
                                >
                                  <input
                                    type="radio"
                                    id="male"
                                    name="gender"
                                    value="Male"
                                    onChange={(e) =>
                                      handleFRWSampleDetails(e, "string")
                                    }
                                    checked={
                                      FRWSampleDetails?.gender === "Male"
                                    }
                                    className="form-check-input"
                                  />
                                  Male
                                </label>

                                <label
                                  className="form-check-label"
                                  htmlFor="Female"
                                >
                                  <input
                                    type="radio"
                                    id="female"
                                    name="gender"
                                    value="Female"
                                    onChange={(e) =>
                                      handleFRWSampleDetails(e, "string")
                                    }
                                    checked={
                                      FRWSampleDetails?.gender === "Female"
                                    }
                                    className="form-check-input"
                                  />
                                  Female
                                </label>
                              </div>
                            </div>
                          </div>
                          <div className="row mt-3">
                            <div className="col-lg-3">
                              <label className="form-check-label">Age</label>
                            </div>
                            <div className="col-lg-9">
                              <div className="row">
                                <div className="col-lg-2">
                                  <input
                                    type="number"
                                    className="form-control"
                                    name="years"
                                    value={FRWSampleDetails?.years}
                                    onChange={(e) =>
                                      handleFRWSampleDetails(e, "number")
                                    }
                                    placeholder="yrs"
                                  />
                                </div>
                                <div className="col-lg-2">
                                  <input
                                    type="number"
                                    className="form-control"
                                    name="months"
                                    value={FRWSampleDetails?.months}
                                    onChange={(e) =>
                                      handleFRWSampleDetails(e, "number")
                                    }
                                    placeholder="mths"
                                  />
                                </div>
                                <div className="col-lg-2">
                                  <input
                                    type="number"
                                    className="form-control"
                                    name="weeks"
                                    value={FRWSampleDetails?.weeks}
                                    onChange={(e) =>
                                      handleFRWSampleDetails(e, "number")
                                    }
                                    placeholder="weeks"
                                  />
                                </div>
                              </div>
                            </div>
                          </div>
                          <br />
                          <div className="row">
                            <div className="col-lg-3">
                              <label className="form-check-label" htmlFor="dob">
                                Date of Birth
                              </label>
                            </div>
                            <div className="col-lg-3">
                              <input
                                type="date"
                                id="dob"
                                name="dateofBirth"
                                value={
                                  FRWSampleDetails?.dateofBirth
                                    ? moment(
                                        FRWSampleDetails?.dateofBirth
                                      ).format("YYYY-MM-DD")
                                    : ""
                                }
                                max={maxdate}
                                onChange={(e) =>
                                  handleFRWSampleDetails(e, "string")
                                }
                                className="form-control"
                              />
                            </div>
                          </div>
                          <div className="row">
                            <div className="col-lg-3">
                              <label
                                className="form-check-label"
                                htmlFor="countryOfResidence"
                              >
                                Country of Residence
                              </label>
                            </div>
                            <div className="col-lg-9">
                              <label>
                                Please list the Countries of Residence if
                                different from Country of Birth for the past 2
                                years
                              </label>
                            </div>
                          </div>
                          <div className="row">
                            <div className="col-lg-3"></div>
                            <div className="col-lg-9">
                              <textarea
                                id="CountryofResidence"
                                name="countryofResidence"
                                value={FRWSampleDetails?.countryofResidence}
                                onChange={(e) =>
                                  handleFRWSampleDetails(e, "string")
                                }
                                className="form-control"
                              ></textarea>
                            </div>
                          </div>
                        </>
                      )}

                      <div className="row mb-3">
                        <div className="col-lg-2 d-flex align-items-center">
                          <label
                            className="form-check-label"
                            htmlFor="flexRadioDefault1"
                          >
                            Clinical History
                            <span className="star-red">*</span>
                          </label>
                        </div>
                        <div className="col-lg-10 d-flex flex-wrap align-items-center">
                          {clinicalHistoryOptions &&
                            clinicalHistoryOptions.map((x) => {
                              return (
                                <div
                                  key={x.id}
                                  className="form-check form-check-inline"
                                >
                                  <input
                                    className={`form-check-input mt-10 ${
                                      FRWSampleDetails?.clinicalHistoryErrMsg
                                        ? "border-danger"
                                        : ""
                                    }`}
                                    type="radio"
                                    name="clinicalHistory"
                                    id={`${x.name}-check`}
                                    value={x.id}
                                    onChange={(e) =>
                                      handleFRWSampleDetails(e, "number")
                                    }
                                    disabled={
                                      amendCase === "CASE4" ||
                                      isCancelRequest ||
                                      IsAcknowledgeRequest
                                    }
                                    checked={
                                      FRWSampleDetails.clinicalHistory === x.id
                                    }
                                  />
                                  <label
                                    className="form-check-label"
                                    htmlFor={`${x.name}-check`}
                                  >
                                    {x.name}
                                  </label>
                                </div>
                              );
                            })}
                          {FRWSampleDetails?.clinicalHistoryErrMsg && (
                            <div className="error-message">
                              <FontAwesomeIcon
                                className="me-1"
                                icon={faCircleExclamation}
                              />
                              Please fill Clinical History.
                            </div>
                          )}
                        </div>
                      </div>
                      {FRWSampleDetails?.clinicalHistory === 2 && (
                        <div className="row">
                          <div className="col-lg-2">
                            <label className="form-check-label" htmlFor="">
                              <b>Disease Started on</b>
                            </label>
                          </div>
                          <div className="col-lg-4 align-disease">
                            <div className="input-group date" id="datepicker">
                              <input
                                type="date"
                                className={`form-control`}
                                max={maxdate}
                                name="diseaseStartedOn"
                                value={
                                  FRWSampleDetails?.diseaseStartedOn
                                    ? moment(
                                        FRWSampleDetails?.diseaseStartedOn
                                      ).format("YYYY-MM-DD")
                                    : ""
                                }
                                disabled={
                                  amendCase === "CASE4" ||
                                  isCancelRequest ||
                                  IsAcknowledgeRequest
                                }
                                onChange={(e) =>
                                  handleFRWSampleDetails(e, "date")
                                }
                                required
                              />
                            </div>
                          </div>
                          <div className="col-lg-6 align-disease">
                            <b>OR</b>
                            <input
                              type="number"
                              className="form-control ms-2"
                              placeholder=""
                              name="ago"
                              disabled={
                                amendCase === "CASE4" ||
                                isCancelRequest ||
                                IsAcknowledgeRequest
                              }
                              onChange={(e) =>
                                handleFRWSampleDetails(e, "number")
                              }
                              value={FRWSampleDetails?.ago}
                            />
                            <select
                              className="form-select ms-2"
                              aria-label="Default select example"
                              name="diseaseStartedOnOptions"
                              value={FRWSampleDetails?.diseaseStartedOnOptions}
                              disabled={
                                amendCase === "CASE4" || isCancelRequest
                              }
                              onChange={(e) =>
                                handleFRWSampleDetails(e, "number")
                              }
                            >
                              <option selected />
                              {ageAffectedOptions &&
                                ageAffectedOptions.map((x) => {
                                  return (
                                    <option key={x.id} value={x.id}>
                                      {x.name}
                                    </option>
                                  );
                                })}
                            </select>
                            <p className="ms-2">ago</p>
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                </Tab>
                <Tab eventKey={2} title="Samples & Tests">
                  {samplesAndTests &&
                    samplesAndTests.map(
                      (sample: IFRWSamplesAndTests, index: number) => {
                        return (
                          <div className="personal-info">
                            <div
                              className="clonable-block"
                              data-toggle="cloner"
                            >
                              <div className="clonable" data-clone-number={1}>
                                <div className="info-heading">
                                  {amendCase !== "CASE3" &&
                                  amendCase !== "CASE4" &&
                                  !isCancelRequest &&
                                  !IsAcknowledgeRequest ? (
                                    <ul className="card-icons float-end">
                                      <li>
                                        <button
                                          className="icon-button"
                                          title="New"
                                          onClick={handleAddSample}
                                        >
                                          <FontAwesomeIcon icon={faPlus} />
                                        </button>
                                        {showCopyControls &&
                                          copyIndex === index && (
                                            <div className="copy-controls">
                                              <input
                                                type="number"
                                                className="col-lg-3"
                                                min="1"
                                                value={copyCount}
                                                onChange={handleCopyInputChange}
                                              />
                                            </div>
                                          )}
                                      </li>
                                      <li className="copy-button-container">
                                        <button
                                          className="icon-button"
                                          title="Copy"
                                          onClick={() =>
                                            handleCopyButtonClick(index)
                                          }
                                        >
                                          <FontAwesomeIcon icon={faCopy} />
                                        </button>
                                      </li>

                                      {!(
                                        amendCase == "CASE3" &&
                                        sample?.disableDelete
                                      ) ? (
                                        <li>
                                          <button
                                            className="icon-button"
                                            onClick={() =>
                                              handleDeleteSample(sample?.id)
                                            }
                                          >
                                            <FontAwesomeIcon
                                              icon={faTrashCan}
                                            />
                                          </button>
                                        </li>
                                      ) : (
                                        ""
                                      )}
                                    </ul>
                                  ) : (
                                    ""
                                  )}

                                  <h2 className="pb-0">Sample {index + 1}</h2>
                                </div>
                                <div className="info-content">
                                  <div className="table-responsive mt-2 mb-2">
                                    <table className="table table-striped product_table start_table">
                                      <thead>
                                        <tr>
                                          <th colSpan={1} className="w-20">
                                            Sample Marking
                                            <span className="star-red">*</span>
                                          </th>
                                          <th colSpan={1} className="w-20">
                                            Species
                                            <span className="star-red">*</span>
                                          </th>
                                          <th colSpan={1} className="w-20">
                                            Breed
                                            <span className="star-red">*</span>
                                          </th>
                                          <th colSpan={1} className="w-20">
                                            Sample Description
                                            <span className="star-red">*</span>
                                          </th>
                                          <th colSpan={1} className="w-20">
                                            Test Information
                                            <span className="star-red">*</span>
                                          </th>
                                        </tr>
                                      </thead>
                                      <tbody>
                                        <tr>
                                          <td>
                                            <input
                                              type="text"
                                              className="form-control"
                                              name="sampleMarking"
                                              value={sample.sampleMarking}
                                              onChange={(e) =>
                                                handleSamplesAndTestsChange(
                                                  index,
                                                  "sampleMarking",
                                                  e.target.value
                                                )
                                              }
                                            />
                                          </td>

                                          <td>
                                            <select
                                              className={`form-select ${
                                                sample?.speciesErrMsg
                                                  ? "border-danger"
                                                  : ""
                                              }`}
                                              aria-label="Default select example"
                                              value={sample.species}
                                              name="species"
                                              disabled={
                                                (amendCase == "CASE3" &&
                                                  sample?.disableDelete) ||
                                                amendCase == "CASE4" ||
                                                isCancelRequest ||
                                                IsAcknowledgeRequest
                                              }
                                              onChange={(e) =>
                                                handleSamplesAndTestsChange(
                                                  index,
                                                  "species",
                                                  e.target.value
                                                )
                                              }
                                            >
                                              <option selected />
                                              {speciesOptions &&
                                                speciesOptions.map((x) => {
                                                  return (
                                                    <option
                                                      value={x.speciesName}
                                                    >
                                                      {x.speciesName}
                                                    </option>
                                                  );
                                                })}
                                            </select>
                                            {sample?.speciesErrMsg && (
                                              <div className="error-message">
                                                <FontAwesomeIcon
                                                  className="me-1"
                                                  icon={faCircleExclamation}
                                                />
                                                Please fill Species.
                                              </div>
                                            )}
                                          </td>
                                          <td>
                                            {" "}
                                            <select
                                              className={`form-select ${
                                                sample?.breedErrMsg
                                                  ? "border-danger"
                                                  : ""
                                              }`}
                                              aria-label="Default select example"
                                              value={sample.breed}
                                              name="breed"
                                              disabled={
                                                (amendCase == "CASE3" &&
                                                  sample?.disableDelete) ||
                                                amendCase == "CASE4" ||
                                                isCancelRequest ||
                                                IsAcknowledgeRequest
                                              }
                                              onChange={(e) =>
                                                handleSamplesAndTestsChange(
                                                  index,
                                                  "breed",
                                                  e.target.value
                                                )
                                              }
                                            >
                                              <option selected />
                                              {breedOptions &&
                                                breedOptions.map((x) => {
                                                  return (
                                                    <option value={x.breedName}>
                                                      {x.breedName}
                                                    </option>
                                                  );
                                                })}
                                            </select>
                                            {sample?.breedErrMsg && (
                                              <div className="error-message">
                                                <FontAwesomeIcon
                                                  className="me-1"
                                                  icon={faCircleExclamation}
                                                />
                                                Please fill Breed.
                                              </div>
                                            )}
                                          </td>
                                          <td>
                                            <select
                                              className={`form-select ${
                                                sample?.specimenDescriptionErrMsg
                                                  ? "border-danger"
                                                  : ""
                                              }`}
                                              aria-label="Default select example"
                                              value={sample.specimenDescription}
                                              name="specimenDescription"
                                              disabled={
                                                (amendCase == "CASE3" &&
                                                  sample?.disableDelete) ||
                                                amendCase == "CASE4" ||
                                                isCancelRequest ||
                                                IsAcknowledgeRequest
                                              }
                                              onChange={(e) =>
                                                handleSamplesAndTestsChange(
                                                  index,
                                                  "specimenDescription",
                                                  e.target.value
                                                )
                                              }
                                            >
                                              <option selected />
                                              {specimenOptions &&
                                                specimenOptions.map((x) => {
                                                  return (
                                                    <option
                                                      value={
                                                        x.labSpecimenDescription
                                                      }
                                                    >
                                                      {x.labSpecimenDescription}
                                                    </option>
                                                  );
                                                })}
                                            </select>
                                            {sample?.specimenDescriptionErrMsg && (
                                              <div className="error-message">
                                                <FontAwesomeIcon
                                                  className="me-1"
                                                  icon={faCircleExclamation}
                                                />
                                                Please fill Specimen
                                                Description.
                                              </div>
                                            )}
                                          </td>

                                          <td>
                                            <button
                                              className="btn btn-outline-success w-100 "
                                              type="button"
                                              onClick={() =>
                                                handleShowSearchTestsModal(
                                                  index
                                                )
                                              }
                                            >
                                              Search Test
                                            </button>
                                          </td>
                                        </tr>
                                        <tr>
                                          <td className="fnt-wg">
                                            <div className="mb-2 ">
                                              <label
                                                htmlFor="staticEmail"
                                                className="col-form-label"
                                              >
                                                Sampling From Date
                                                <span className="star-red">
                                                  *
                                                </span>
                                              </label>
                                              <div
                                                className="input-group date"
                                                id="datepicker"
                                              >
                                                <input
                                                  type="date"
                                                  className={`form-control`}
                                                  placeholder="Sampling From Date"
                                                  value={
                                                    sample.samplingFromDate
                                                      ? moment(
                                                          sample.samplingFromDate
                                                        ).format("YYYY-MM-DD")
                                                      : ""
                                                  }
                                                  max={maxdate}
                                                  onChange={(e) =>
                                                    handleSamplesAndTestsChange(
                                                      index,
                                                      "samplingFromDate",
                                                      e.target.value
                                                    )
                                                  }
                                                />
                                              </div>
                                            </div>
                                          </td>
                                          <td className="fnt-wg">
                                            <div className="mb-2 ">
                                              <label
                                                htmlFor="staticEmail"
                                                className="col-form-label"
                                              >
                                                Sampling To Date
                                                <span className="star-red">
                                                  *
                                                </span>
                                              </label>
                                              <div
                                                className="input-group date"
                                                id="datepicker"
                                              >
                                                <input
                                                  type="date"
                                                  className={`form-control`}
                                                  name="samplingToDate"
                                                  value={
                                                    sample.samplingToDate
                                                      ? moment(
                                                          sample.samplingToDate
                                                        ).format("YYYY-MM-DD")
                                                      : ""
                                                  }
                                                  onChange={(e) =>
                                                    handleSamplesAndTestsChange(
                                                      index,
                                                      "samplingToDate",
                                                      e.target.value
                                                    )
                                                  }
                                                  max={maxdate}
                                                />
                                              </div>
                                            </div>
                                          </td>

                                          <td className="fnt-wg tr-ignore">
                                            <div className="mb-3 ">
                                              <div className="mb-2">
                                                <label
                                                  htmlFor="staticEmail"
                                                  className="col-form-label"
                                                >
                                                  Sampled by
                                                </label>
                                                <div className="input-group date">
                                                  <input
                                                    type="text"
                                                    className="form-control"
                                                    name="sampledBy"
                                                    value={sample.sampledBy}
                                                    onChange={(e) =>
                                                      handleSamplesAndTestsChange(
                                                        index,
                                                        "sampledBy",
                                                        e.target.value
                                                      )
                                                    }
                                                  />
                                                </div>
                                              </div>
                                            </div>
                                          </td>
                                          <td className="fnt-wg tr-ignore">
                                            <div className="mb-3 ">
                                              <div className="mb-2">
                                                <label
                                                  htmlFor="staticEmail"
                                                  className="col-form-label"
                                                >
                                                  Alive/Dead
                                                  <span className="star-red">
                                                    *
                                                  </span>
                                                </label>
                                                <div className="input-group date">
                                                  <select
                                                    className={`form-select ${
                                                      sample?.aliveDeadErrMsg
                                                        ? "border-danger"
                                                        : ""
                                                    }`}
                                                    aria-label="Default select example"
                                                    value={sample.aliveDead}
                                                    name="aliveDead"
                                                    onChange={(e) =>
                                                      handleSamplesAndTestsChange(
                                                        index,
                                                        "aliveDead",
                                                        e.target.value
                                                      )
                                                    }
                                                    // disabled={
                                                    //   (amendCase == "CASE3" &&
                                                    //     sample?.disableDelete) ||
                                                    //   amendCase == "CASE4" ||
                                                    //   isCancelRequest ||
                                                    //   IsAcknowledgeRequest
                                                    // }
                                                  >
                                                    <option selected />
                                                    {aliveDeadOptions &&
                                                      aliveDeadOptions.map(
                                                        (x) => {
                                                          return (
                                                            <option
                                                              value={x.id}
                                                            >
                                                              {x.name}
                                                            </option>
                                                          );
                                                        }
                                                      )}
                                                  </select>
                                                  {/* {sample?.aliveDeadErrMsg && (
                                              <div className="error-message">
                                                <FontAwesomeIcon
                                                  className="me-1"
                                                  icon={faCircleExclamation}
                                                />
                                                Please fill Alive/Dead.
                                              </div>
                                            )} */}
                                                </div>
                                              </div>
                                            </div>
                                          </td>
                                          <td className="br-1">
                                            {sample.labFRWTestDetail &&
                                              sample.labFRWTestDetail
                                                .filter(
                                                  (test) =>
                                                    test.testDescription !== ""
                                                )
                                                .map((test, testIndex) => (
                                                  <div
                                                    className="test-detail"
                                                    key={testIndex}
                                                  >
                                                    <span className="test-description">
                                                      {test.testDescription}
                                                    </span>
                                                    <span
                                                      className="test-remove-icon"
                                                      onClick={() =>
                                                        handleRemoveTest(
                                                          sample.labFRWTestDetail,
                                                          test.testDescription,
                                                          index
                                                        )
                                                      }
                                                    >
                                                      <i className="bi bi-dash-circle"></i>
                                                    </span>
                                                  </div>
                                                ))}
                                          </td>
                                        </tr>
                                        <tr>
                                          <td className="fnt-wg tr-ignore">
                                            <div className="mb-3 ">
                                              <div className="mb-2">
                                                <label
                                                  htmlFor="staticEmail"
                                                  className="col-form-label float-start"
                                                >
                                                  Number of Samples
                                                </label>
                                                <div className="input-group date">
                                                  <input
                                                    type="number"
                                                    className="form-control"
                                                    onChange={(e) =>
                                                      handleSamplesAndTestsChange(
                                                        index,
                                                        "numberofSamples",
                                                        e.target.value
                                                      )
                                                    }
                                                    name="numberofSamples"
                                                    value={
                                                      sample.numberofSamples
                                                    }
                                                  />
                                                </div>
                                              </div>
                                            </div>
                                          </td>
                                        </tr>
                                      </tbody>
                                    </table>
                                  </div>
                                  <hr></hr>
                                </div>
                              </div>
                            </div>
                          </div>
                        );
                      }
                    )}
                </Tab>
                <Tab eventKey={3} title="My Preference">
                  <div className="personal-info">
                    <div className="clonable-block">
                      <div className="clonable">
                        <div className="info-content">
                          <div className="row">
                            <div className="col-lg-6">
                              <div className="row">
                                <div className="col-lg-5">
                                  <label
                                    className="form-check-label"
                                    htmlFor="specialInstructions"
                                  >
                                    Special Instructions/ Additional Information
                                  </label>
                                </div>
                                <div className="col-lg-7">
                                  <textarea
                                    className="form-control"
                                    name="SpecialInstructions"
                                    onChange={(e) =>
                                      handleMyPreference(e, "input")
                                    }
                                    disabled={
                                      amendCase === "CASE4" ||
                                      isCancelRequest ||
                                      IsAcknowledgeRequest
                                    }
                                    value={Preference.SpecialInstructions}
                                  />
                                </div>
                              </div>
                            </div>
                            <div className="col-lg-6">
                              <div className="row mt-2 mt-lg-0">
                                <div className="col-lg-5">
                                  <label
                                    className="form-check-label"
                                    htmlFor="otherRemarks"
                                  >
                                    Other Remarks
                                  </label>
                                </div>
                                <div className="col-lg-7">
                                  <textarea
                                    className="form-control"
                                    name="remarks"
                                    value={Preference.remarks}
                                    disabled={
                                      amendCase === "CASE4" ||
                                      isCancelRequest ||
                                      IsAcknowledgeRequest
                                    }
                                    onChange={(e) =>
                                      handleMyPreference(e, "input")
                                    }
                                  />
                                </div>
                              </div>
                            </div>
                          </div>
                          <br />
                          <div className="row mt-2">
                            <div className="col-lg-6">
                              <div className="row">
                                <div className="col-lg-5">
                                  <label
                                    htmlFor="supportDocuments"
                                    className="form-check-label"
                                  >
                                    Support Documents
                                  </label>
                                </div>
                                <div className="col-lg-7">
                                  <input
                                    type="file"
                                    className="form-control"
                                    id="supportDocuments"
                                    onChange={handledFileChange}
                                    disabled={
                                      amendCase === "CASE4" ||
                                      isCancelRequest ||
                                      IsAcknowledgeRequest
                                    }
                                  />
                                  <div className="col-lg-12">
                                    {Preference?.SupportDocuments ? (
                                      <div className="file-view">
                                        {Preference?.SupportDocumentName}
                                      </div>
                                    ) : (
                                      ""
                                    )}
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </Tab>
              </Tabs>
            </div>
          </div>
          <div className="text-end mt-3 mb-3">
            <button className="btn btn-secondry  px-4">Save Draft</button>
            <button
              className="btn btn-secondry  px-4"
              onClick={handlePreviousClick}
            >
              Previous
            </button>

            <button
              className="btn btn-primary px-4"
              onClick={handleNextClick}
              type="button"
            >
              Next
            </button>
          </div>
        </div>
      </Container>
      <Modal
        className="popup-2"
        show={showSearchTestsModal}
        onHide={handleCloseSearchTestsModal}
        backdrop="static"
        keyboard={false}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Assign Tests</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <form>
            <h3>Search for Other Tests</h3>
            <div className="tests-cnt pb-2">
              <div className="mb-3 row">
                <label
                  htmlFor="flexCheckDesc"
                  className="col-sm-3 col-form-label"
                >
                  Test Laboratory
                  <span className="star-red">*</span>
                </label>
                <div className="col-sm-9">
                  <select
                    className="form-select"
                    aria-label="Test Laboratory"
                    value={selectedTestLaboratory}
                    onChange={(e) => {
                      setSelectedTestLaboratory(e.target.value);
                    }}
                  >
                    <option value="">Select Test Laboratory</option>
                    {labtestoptions.map((item, index) => (
                      <option key={index} value={item.title}>
                        {item.title}
                      </option>
                    ))}
                  </select>
                </div>
              </div>

              <div className="mb-1 row"></div>
              <div className="mb-3 row">
                <label
                  htmlFor="flexCheckDesc"
                  className="col-sm-3 col-form-label"
                >
                  Test Description
                  <span className="star-red">*</span>
                </label>
                <div className="col-sm-9">
                  <input
                    type="text"
                    id="flexCheckDesc"
                    placeholder=""
                    autoComplete="off"
                    value={testDescription}
                    required
                    onChange={(e) => setTestDescription(e.target.value)}
                    disabled={
                      amendCase == "CASE4" ||
                      isCancelRequest ||
                      IsAcknowledgeRequest
                    }
                    className={`form-control ${
                      !testDescription ? "border-danger op05" : ""
                    }`}
                  />
                  <br />

                  <Button
                    variant="primary"
                    className="float-end"
                    onClick={handleSearch}
                  >
                    Search
                  </Button>
                </div>
              </div>
            </div>
            <h3>Examination/Diagnostic Tests</h3>
            <div
              className="tests-cnt csp-maxh-200 csp-overflow-y-auto csp-display-block"
            >
              <h4>Examination/Diagnostic Tests</h4>

              {testOptions.map((test, index) => (
                <div className="form-check" key={index}>
                  <input
                    className="form-check-input"
                    type="checkbox"
                    value={test.name}
                    id={`testOption${index}`}
                    onChange={(e) =>
                      toggleTestSelection(
                        test.labCodeMasterID,
                        e.target.checked
                      )
                    }
                  />
                  <label
                    className="form-check-label"
                    htmlFor={`testOption${index}`}
                  >
                    {test.name}
                  </label>
                </div>
              ))}
            </div>
          </form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleCloseSearchTestsModal}>
            Close
          </Button>
          <Button
            variant="primary"
            onClick={() => {
              handleAddTests();
              handleCloseSearchTestsModal();
            }}
          >
            Add
          </Button>
        </Modal.Footer>
      </Modal>

      <Footer />
    </>
  );
}

export default CAVSFRWSampleDetails;
